import React, { useState, useEffect, useRef } from 'react';

import { DAYS, WINDOWS, emptySchedule, resolveAvailabilitySchedule } from '../../utils/weeklyAvailability';



export default function WeeklyAvailability({ worker = {}, onSave }) {

  const resolved = resolveAvailabilitySchedule(worker);
  const serialized = JSON.stringify(resolved.schedule || emptySchedule());
  const [draft, setDraft] = useState(() => JSON.parse(serialized));
  const [baseline, setBaseline] = useState(serialized);
  const [state, setState] = useState('idle');
  const [error, setError] = useState('');
  const lastRemote = useRef(serialized);
  const dirty = JSON.stringify(draft) !== baseline;
  useEffect(() => {
    if (serialized !== lastRemote.current) {
      if (!dirty) { setDraft(JSON.parse(serialized)); setBaseline(serialized); }
      lastRemote.current = serialized;
    }
  }, [serialized, dirty]);
  const changeDay = (day, values) => { setDraft(previous => ({ ...previous, [day]: [...values] })); setState('idle'); };
  async function save() {
    setState('saving'); setError('');
    try { const saved = await onSave(draft); setDraft(saved); setBaseline(JSON.stringify(saved)); setState('saved'); }
    catch (err) { setError(err.message || 'Please try again.'); setState('failed'); }
  }
  return <section className="we-weekly" aria-label="Weekly availability">

    <h2>Days & shifts open to work</h2>

    <p>Your normal weekly preferences. Overnight shifts belong to the day they start. Quick Status does not erase these selections.</p>

    <p>These preferences are saved to your profile. Planner assignment decisions remain unchanged.</p>
    {resolved.source === 'legacy' && <p>Loaded from earlier preferences. Review and save to confirm your weekly schedule.</p>}
    {resolved.source === 'missing' && <p>No weekly schedule saved yet. Select your normal shift windows, then save.</p>}
    <div className="we-weekly-save"><button type="button" onClick={save} disabled={state === 'saving' || (!dirty && (resolved.source === 'canonical' || state === 'saved')) || !onSave}>{state === 'saving' ? 'Saving…' : 'Save availability'}</button>
      <span role="status">{state === 'saving' ? 'Saving…' : state === 'failed' ? 'Save failed — retry' : dirty ? 'Unsaved changes' : state === 'saved' ? 'Saved' : resolved.source === 'canonical' ? 'Saved schedule' : 'Not saved yet'}</span>
      {error && <p role="alert">{error}</p>}
    </div>
    <fieldset disabled={state === 'saving'} className="we-weekly-editor">
    <div className="we-weekly-tools">

      <button type="button" onClick={() => setDraft(previous => ({ ...previous, ...Object.fromEntries(DAYS.slice(1,5).map(([day]) => [day, [...previous.mon]])) }))}>Copy Monday to weekdays</button>

      <button type="button" onClick={() => setDraft(emptySchedule())}>Clear all</button>

    </div>

    <div className="we-weekly-grid">

      {DAYS.map(([day, label]) => <fieldset key={day} className="we-weekly-day">

        <legend>{label}</legend>

        <div className="we-weekly-options">{WINDOWS.map(([key, text]) => <label key={key} className={draft[day].includes(key) ? 'selected' : ''}>

          <input type="checkbox" aria-label={`${label} ${text}`} checked={draft[day].includes(key)} onChange={e => changeDay(day, e.target.checked ? [...draft[day], key] : draft[day].filter(value => value !== key))}/><span>{text}</span>

        </label>)}</div>

        <div className="we-weekly-day-tools"><span>{draft[day].length ? `${draft[day].length} windows selected` : 'Unavailable'}</span><button type="button" aria-label={`Select all ${label} shifts`} onClick={() => changeDay(day, WINDOWS.map(([key]) => key))}>Select all</button><button type="button" aria-label={`Clear ${label}`} onClick={() => changeDay(day, [])}>Clear</button></div>

      </fieldset>)}

    </div>
    </fieldset>
  </section>;

}
